var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "common-content",
    [
      _c("page-title", { attrs: { pageName: _vm.pros } }),
      _c("div", { staticClass: "project-list" }, [
        _c(
          "ul",
          _vm._l(_vm.descPageData, function(item, index) {
            return _c(
              "li",
              {
                key: item.id,
                staticClass: "project-list_detail",
                class: { left: index % 2 === 1 }
              },
              [
                _c(
                  "nuxt-link",
                  {
                    attrs: { to: "/project/" + item.id + "?lang=" + _vm.lang }
                  },
                  [
                    _c("img", { attrs: { src: item.mainImg, alt: "" } }),
                    _c("div", { staticClass: "project-modal" }, [
                      _c("div", { staticClass: "modal-text" }, [
                        _c("hr"),
                        _c("h2", [_vm._v(_vm._s(item.title))]),
                        _c("h4", [_vm._v(_vm._s(item.time))])
                      ])
                    ])
                  ]
                )
              ],
              1
            )
          }),
          0
        )
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-564ed0b3", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-564ed0b3","hasScoped":false,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./pages/project/index.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-564ed0b3","hasScoped":false,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./pages/project/index.vue
// module chunks = 9